/*
 * Module for the advanced conversation area of the Topic page.
 * It allows the user to edit branching conversations.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicConversation/topicConversationView",
  "modules/topicsSplit/topic/topicDiagramArea/topicDiagramAreaModule",
  "modules/topicsSplit/topic/topicResponse/topicResponseModule",
  "modules/topicsSplit/topic/topicDecisionArea/topicDecisionAreaModule",
], function (
  Marionette,
  Messenger,
  TopicConversationView,
  TopicDiagramAreaModule,
  TopicResponseModule,
  TopicDecisionAreaModule,
) {
  var TopicConversationController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicConversation";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (conversation, liveConversationRoot) {
      const readOnly = Messenger.reqres.request("topic:read:only");
      //if the conversation is branching, fire an event to show the conversation tab
      conversation.onSynced(() => this._showTab(conversation));
      this.layout = new TopicConversationView.topicConversationLayout();
      this.diagram = this.addSubModule(
        new TopicDiagramAreaModule({ region: this.layout.diagram, readOnly: readOnly }),
      );
      this.response = this.addSubModule(new TopicResponseModule({ region: this.layout.response }));
      this.decisionChoice = this.addSubModule(
        new TopicDecisionAreaModule({ region: this.layout.decisionChoice }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(conversation, liveConversationRoot);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function (conversation, liveConversationRoot) {
      this.diagram.show(conversation);
      this.response.show(conversation, liveConversationRoot);
      this.decisionChoice.show(conversation);
    },
    _showTab: function (conversation) {
      if (conversation.decisionCol && conversation.decisionCol.length > 0) {
        Messenger.vent.trigger("show:conversation:tab");
      }
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "conversation:created",
        function () {
          //now that a conversation with branches has been created, show the tab for this pane
          Messenger.vent.trigger("show:conversation:tab");
        },
        this,
      );
    },
  });

  return TopicConversationController;
});
